module.exports = __webpack_public_path__ + "media/assets/images/category/Sports@2x-bfb3753041e3b6add4c56d4422a4ab20.png";